import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottomFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-bottom-full, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutBottomFull"><path d="M3 14V3H21V14H3Z" fill="currentColor"/><path d="M3 15V21H21V15H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutBottomFull;
